import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import {
    IThinkAnalyticsSearchSuggestionRequest,
    IThinkAnalyticsSearchSuggestionResponse,
    IThinkAnalyticsSearchPARequest,
    IThinkAnalyticsSearchPAResponse,
} from '../../entity/interface/iThinkAnalyticsSearch';
import { IGetSearchSuggestionsUseCase } from '../../core/usecases/thinkAnalytics/GetSearchSuggestionsUseCase';
import { IGetSearchPAUseCase } from '../../core/usecases/thinkAnalytics/GetSearchPAUseCase';

export interface IThinkAnalyticsSearchService {
    getSearchSuggestions(
        payload: IThinkAnalyticsSearchSuggestionRequest,
        identityToken: string
    ): Promise<IThinkAnalyticsSearchSuggestionResponse>;

    searchPA(payload: IThinkAnalyticsSearchPARequest, identityToken: string): Promise<IThinkAnalyticsSearchPAResponse>;
}

export class ThinkAnalyticsSearchService implements IThinkAnalyticsSearchService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get getSearchSuggestionsUseCase(): IGetSearchSuggestionsUseCase {
        return container.resolve<IGetSearchSuggestionsUseCase>(DI.USECASES.IGetSearchSuggestionsUseCase);
    }

    private get getSearchPAUseCase(): IGetSearchPAUseCase {
        return container.resolve<IGetSearchPAUseCase>(DI.USECASES.IGetSearchPAUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getSearchSuggestions(
        payload: IThinkAnalyticsSearchSuggestionRequest,
        identityToken: string
    ): Promise<IThinkAnalyticsSearchSuggestionResponse> {
        const searchSuggestions = await this.getSearchSuggestionsUseCase.execute(payload, identityToken);
        return searchSuggestions;
    }

    async searchPA(
        payload: IThinkAnalyticsSearchPARequest,
        identityToken: string
    ): Promise<IThinkAnalyticsSearchPAResponse> {
        const searchSuggestions = await this.getSearchPAUseCase.execute(payload, identityToken);
        return searchSuggestions;
    }
}
